// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__mcbG0","isGreen":"Badge_isGreen__X5hbG","isRed":"Badge_isRed__9dT+4","isPurple":"Badge_isPurple__XXTA5","isGray":"Badge_isGray__CB3W6"};